import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes } from '../../../../src/app/shared/model';

@Component({
  selector: 'app-jobs-lista',
  templateUrl: './jobs-lista.component.html',
  styleUrls: ['./jobs-lista.component.scss']
})
export class JobListaComponent implements OnInit {

  canViewMovimientosSegundoVencimiento: boolean = false;

  constructor(
    private sharedFunctions: SharedFunctions,
    private menuService: MenuFuncionService
  ) {

  }

  ngOnInit() {
    this.loadView();
  }

  loadView() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.JOBS).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canViewMovimientosSegundoVencimiento = data.Result.some(x => x == MenuFuncionCodes.JOBS_MOVIMIENTO_SEGUNDO_VENCIMIENTO);
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }
}